(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAnnouncementBar(sectionId) {
    var carouselId = 'ab-carousel-' + sectionId;
    var wrapper = document.getElementById(carouselId);
    if (!wrapper) return;

    var section = wrapper.closest('.announcement-bar-section');
    if (!section) return;

    var track = wrapper.querySelector('.ab-carousel-track');
    var slides = wrapper.querySelectorAll('.ab-slide');
    var prevBtn = section.querySelector('.ab-prev');
    var nextBtn = section.querySelector('.ab-next');

    if (!track || slides.length === 0) return;

    var current = 0;
    var total = slides.length;
    var autoplaySpeed = parseFloat(getComputedStyle(section).getPropertyValue('--ab-autoplay-speed')) || 3;
    var timer = null;
    var isHovered = false;

    function goTo(index) {
      if (index >= total) index = 0;
      if (index < 0) index = total - 1;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (total <= 1) return;
      timer = setInterval(function() {
        if (!isHovered) next();
      }, autoplaySpeed * 1000);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        next(); stopAutoplay(); startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        prev(); stopAutoplay(); startAutoplay();
      });
    }

    section.addEventListener('mouseenter', function() { isHovered = true; });
    section.addEventListener('mouseleave', function() { isHovered = false; });

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[id^="ab-carousel-"]').forEach(function(el) {
      var sectionId = el.id.replace('ab-carousel-', '');
      initAnnouncementBar(sectionId);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function(event) {
    var el = event.target.querySelector('[id^="ab-carousel-"]');
    if (el) initAnnouncementBar(el.id.replace('ab-carousel-', ''));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
